module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_83-ce85ca881a755f0be976601c3934e1fe.png";